import { render, staticRenderFns } from "./app.vue?vue&type=template&id=e33fe2d4&scoped=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"
import style0 from "./app.vue?vue&type=style&index=0&id=e33fe2d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33fe2d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VCol,VMain})
